module.exports = __webpack_public_path__ + "media/images/arrow-prev-6e38dc5e1700c6c297292c23540ae824.svg";